import { Component, inject } from '@angular/core';
import { Toast, ToastService } from './toast.service';
import { AsyncPipe, NgClass, NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [NgClass, NgTemplateOutlet, AsyncPipe],
  styleUrls: ['../color-scheme.scss'],
  templateUrl: './toast.component.html',
})
export class ToastComponent {
  toastService = inject(ToastService);
  toasts$ = this.toastService.toasts$;

  getInfo(type: Toast['type']) {
    const typeColors = {
      info: { variant: 'blue', label: 'Informação', icon: 'info-circle' },
      error: { variant: 'red', label: 'Erro', icon: 'x-circle' },
      success: { variant: 'green', label: 'Sucesso', icon: 'check-circle' },
      warning: { variant: 'orange', label: 'Aviso', icon: 'alert-circle' },
    };
    return typeColors[type];
  }

  close(index: number) {
    this.toastService.dismiss(index);
  }
}
